// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require("babel-polyfill");
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/index.js";
import Configurator from "./components/Configurator.vue";
import SvgPreview from "./components/SvgPreview.vue";
import PatternUpload from "./components/PatternUpload.vue";
import VueAnalytics from "vue-analytics";
import _ from "lodash";
import * as firebase from "firebase";
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

Vue.use(VueAnalytics, {
  id: "UA-40123969-1",
  router
});

Vue.use(require("vue-moment"));

Vue.prototype._ = _;

window.Vue = Vue;

Vue.config.productionTip = false;

Vue.component("configurator", Configurator);
Vue.component("svgpreview", SvgPreview);
Vue.component("patternUpload", PatternUpload);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  store,
  router: router,
  components: { App },
  template: "<App/>",
  created() {
    firebase.initializeApp({
      apiKey: "AIzaSyCjibRrFudOsfzIHJTO6BLkSoo6ifWYWCQ",
      authDomain: "knotty-custom.firebaseapp.com",
      databaseURL: "https://knotty-custom.firebaseio.com",
      projectId: "knotty-custom",
      storageBucket: "knotty-custom.appspot.com",
      messagingSenderId: "189483229386",
      appId: "1:189483229386:web:49312f1ad719875a"
    });
  }
});

var db = firebase.firestore();



// WEBPACK FOOTER //
// ./src/main.js